import { z } from "zod";

/**
 * AvaliarTreinamentoSchema
 */

export const AvaliarTreinamentoSchema = z.object({
  eficaz: z.coerce.number().default(1),
  dataAvaliacao: z.coerce.date().nullable().default(null),
  avaliador: z.string().nullable().default(null),
  evidenciaObjetiva: z.string().nullable().default(null),
});

/**
 * AvaliarTreinamentoForm
 */

export type AvaliarTreinamentoForm = z.infer<typeof AvaliarTreinamentoSchema>;